import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { PermissionArea } from '@pbt/pbt-ui-components'

import { getCRUDByArea } from '~/store/reducers/auth'
import { getIsCurrentContextSoap, getIsFinalized } from '~/store/reducers/soap'
import type { Modify, SoapTemplateTab } from '~/types'

import SoapRail from '../../collapsibleRail/SoapRail'
import { SoapMainContent } from '../../SoapMainContent'
import { useSoapPageRedirect } from '../../utils/useSoapPageRedirect'
import { useSoapRail } from '../../utils/useSoapRail'

interface SoapV2LayoutProps {
  currentTab: Modify<SoapTemplateTab, { id: string }> | undefined
  soapTabs: Modify<SoapTemplateTab, { id: string }>[] | undefined
}

export const SoapV2Layout = ({ soapTabs, currentTab }: SoapV2LayoutProps) => {
  const SOAPPermissions = useSelector(getCRUDByArea(PermissionArea.SOAP))
  const isSoapFinalized = useSelector(getIsFinalized)
  const isCurrentContextSoap = useSelector(getIsCurrentContextSoap)

  const isReadOnly = isSoapFinalized || !isCurrentContextSoap
  const redirectTo = useSoapPageRedirect(soapTabs)

  const {
    expandedRail,
    hideSoapRail,
    rightRailVisible,
    selectedTab,
    setExpandedRail,
    setRightRailVisible,
    setSelectedTab,
    soapRailClasses,
  } = useSoapRail(isReadOnly)

  return (
    <>
      <SoapMainContent
        currentTab={currentTab}
        hideSoapRail={hideSoapRail}
        rightRailVisible={rightRailVisible}
        soapRailClasses={soapRailClasses}
        soapTabs={soapTabs}
      />
      <SoapRail
        className={classNames(soapRailClasses.rightRail, {
          [soapRailClasses.expandedRail]: expandedRail,
          [soapRailClasses.hidden]: !rightRailVisible,
        })}
        editDisabled={!SOAPPermissions.update}
        expanded={expandedRail}
        redirectTo={redirectTo}
        selectedTab={selectedTab}
        setExpanded={setExpandedRail}
        setSelectedTab={setSelectedTab}
        soapTabs={soapTabs}
        visible={rightRailVisible}
        onVisibilityChange={isReadOnly ? undefined : setRightRailVisible}
      />
    </>
  )
}
